module.exports = __webpack_public_path__ + "static/media/EG-P012.588d1db8.jpg";